import { Box } from '@/components/Box'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { GridCellProps } from '@progress/kendo-react-grid'
import {
  LiveRebateInternalResultsDto,
  LiveRebateInternalResultsKey,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import classNames from 'classnames'
import { Info } from 'lucide-react'
import { FormFieldIconBlock } from 'routes/Transactions/Transactions.styles'

import { GridColumn } from './CampaignDetailsResultsPage'

import styles from './CampaignDetailsForm.module.scss'

const campaignLiveRebateDetailsResultsColumn: GridColumn[] = [
  {
    title: 'Ranking',
    field: LiveRebateInternalResultsKey.ranking,
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      if (item.disqualified) {
        return (
          <td className={styles.disqualified}>
            <Box display='flex' gap={2}>
              Disqualified
              <Tooltip key='top'>
                <TooltipTrigger>
                  <FormFieldIconBlock>
                    <Info size={14} />
                  </FormFieldIconBlock>
                </TooltipTrigger>
                <TooltipContent side='top'>
                  {`Reason: ${item?.disqualificationRule?.businessRule?.name}`}
                </TooltipContent>
              </Tooltip>
            </Box>
          </td>
        )
      } else {
        return (
          <td className={classNames({ [styles.disqualified]: item.disqualified })}>
            {item.ranking}
          </td>
        )
      }
    },
  },
  {
    title: 'Client Name',
    field: LiveRebateInternalResultsKey.client,
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>{item.client}</td>
      )
    },
  },
  {
    title: 'Account',
    field: LiveRebateInternalResultsKey.login,
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>{item.login}</td>
      )
    },
  },
  {
    title: 'Volume',
    field: LiveRebateInternalResultsKey.volume,
    show: true,
    className: 'table-columns__number',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>{item.volume}</td>
      )
    },
  },
  {
    title: 'Rebate',
    field: LiveRebateInternalResultsKey.rebate,
    show: true,
    className: 'table-columns__number',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>{item.rebate}</td>
      )
    },
  },
  {
    title: 'Total Volume',
    field: LiveRebateInternalResultsKey.totalVolume,
    show: true,
    className: 'table-columns__number',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>
          {item.totalVolume}
        </td>
      )
    },
  },
  {
    title: 'Total Rebate',
    field: LiveRebateInternalResultsKey.totalRebate,
    show: true,
    className: 'table-columns__number',
    filterable: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as LiveRebateInternalResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>
          {item.totalRebate}
        </td>
      )
    },
  },
]

export default campaignLiveRebateDetailsResultsColumn
